// extracted by mini-css-extract-plugin
export default {"currencyCell":"CurrencyCell_currencyCell__X9qhs","currency":"CurrencyCell_currency__6cnPN","value":"CurrencyCell_value__woZaH"};